module.exports = __webpack_public_path__ + "img/thumb_25.ebad6f87.jpg";